import { Component, input } from '@angular/core'
import { BricksIconComponent } from '@enbw_bricks/ui'
import { MatTooltipModule } from '@angular/material/tooltip'

@Component({
  selector: 'app-tooltip',
  imports: [BricksIconComponent, MatTooltipModule],
  templateUrl: './tooltip.component.html',
})
export class TooltipComponent {
  text = input<string>('')
}
